import { render, staticRenderFns } from "./SelectHotlistRecipientsDialog.vue?vue&type=template&id=ff0e66c4"
import script from "./SelectHotlistRecipientsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectHotlistRecipientsDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports